import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/platform-content/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/platform-content/obligations', replace: true });
    },
});
